import { render, staticRenderFns } from "./ListModal.vue?vue&type=template&id=97e46540&"
import script from "./ListModal.vue?vue&type=script&lang=js&"
export * from "./ListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97e46540')) {
      api.createRecord('97e46540', component.options)
    } else {
      api.reload('97e46540', component.options)
    }
    module.hot.accept("./ListModal.vue?vue&type=template&id=97e46540&", function () {
      api.rerender('97e46540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/ListModal.vue"
export default component.exports